import { all } from "redux-saga/effects";
import sagaUtils from "../sagaUtils";
import siteRequestFunction from "./siteRequestFunctions";

export default function* rootSaga() {
  yield all(sagaUtils.extractRequestFunctions(siteRequestFunction));
}
